/*
    Generated using Simple-Scaffold
    npx simple-scaffold@latest \
        -t templates/feature -o src/features Actions
*/

import axios from "axios";

export const fetchDetails = async ({ integrationSlug }) => {
    return await axios
        .get(`github/integrations/${integrationSlug}/workflow-runs`)
}
